import React, { memo } from "react";
import styles from "./styles.module.css";

const TabContent = memo(({ isActive, children }) => {
  if (!isActive) return null;
  return (
    <div className={styles["tab-content"]}>
      {typeof children === "string" ? <p>{children}</p> : children}
    </div>
  );
});
export default TabContent;
